import React from 'react';

const RadioGroup = ({ 
  name, 
  value, 
  onChange, 
  options, 
  renderLabel 
}) => {
  return (
    <div className="answer-options">
      {options.map((option, index) => (
        <div key={`${name}_${option.value}`} className="answer-option">
          <input
            type="radio"
            id={`${name}_${option.value}`}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={(e) => onChange(parseInt(e.target.value))}
          />
          <label htmlFor={`${name}_${option.value}`}>
            {renderLabel ? renderLabel(option, index) : option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default RadioGroup;